<div>
	<ul style="list-style-type:none">
		<li *ngFor="let item of items" [ngClass]="{selected:item.isSelected}" (click)="selectItem(item);">{{item.displayText}}
		</li>
	</ul>
</div>
